export const LOGIN_STARTED = "AUTH.LOGIN_STARTED";
export const LOGIN_SUCCESS = "AUTH.LOGIN_SUCCESS";
export const LOGIN_FAIL = "AUTH.LOGIN_FAIL";

export const LOGOUT = "AUTH.LOGOUT";

export const REGISTER_STARTED = "AUTH.REGISTER_STARTED";
export const REGISTER_SUCCESS = "AUTH.REGISTER_SUCCESS";
export const REGISTER_FAIL = "AUTH.REGISTER_FAIL";

export const GET_CURRENT_USER_STARTED = "AUTH.GET_CURRENT_USER_STARTED";
export const GET_CURRENT_USER_SUCCESS = "AUTH.GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAIL = "AUTH.GET_CURRENT_USER_FAIL";

export const UPDATE_PROFILE_STARTED = "AUTH.UPDATE_PROFILE_STARTED";
export const UPDATE_PROFILE_SUCCESS = "AUTH.UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "AUTH.UPDATE_PROFILE_FAIL";
